/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { Grid2 } from "@mui/material";
import Header from "../../components/Header";
import SelectEnterprise from "../../components/SelectEnterprise";
import Input from "../../components/Input";
import { Controller, useForm } from "react-hook-form";
import MultiSelect from "../../components/MultiSelect";
import PageSize from "../../components/Table/PageSize";
import Table from "../../components/Table";
import Pagination from "../../components/Table/Pagination";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useNavigate } from "react-router-dom";
import {
  useCallback,
  useEffect,
  useState,
  SetStateAction,
} from "react";
import { getColumns } from "./columns";
import Button from "../../components/Button";
import DeleteModal from "../../components/DeleteModal";
import { IFiles } from "./types";
import file from "../../api/file/file";
import { Spinner } from "../../components/Spinner";

export default function FilesPage() {
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);

  const [useDataFiles, setUseDataFiles] = useState<any[]>([]);
  const [selectActive, setSelectActive] = useState<number | null>(null);

  const [loading, setLoading] = useState(true); 
  const [deletingFile, setDeletingFile] = useState<IFiles | null>(null);
  const [togglingId, setTogglingId] = useState<string | null>(null);

  const [filterTitle, setFilterTitle] = useState("");
  const [filterStatus, setFilterStatus] = useState<string[]>([]);
  const [selectedValues, setSelectedValues] = useState([]);

  const dataStatus = [
    { value: "ativos", label: "Ativos" },
    { value: "inativos", label: "Inativos" },
  ];

  const schema = z.object({
    title: z.any().optional(),
    status: z.any().optional(),
  });
  type FormSchema = z.infer<typeof schema>;

  const {
    register,
    handleSubmit,
    control,
    reset,
  } = useForm<FormSchema>({
    resolver: zodResolver(schema),
  });

  const listFiles = useCallback(
    async (
      pageSize: number,
      currentPage: number,
      title = "",
      statusValues: string[] = []
    ) => {
      if (!selectActive) return;

      setLoading(true);
      try {
        const pageIndex = currentPage - 1; 

        let activeFilter: boolean | undefined;
        if (statusValues.length === 1) {
          activeFilter = statusValues.includes("ativos");
        }

        const { total, pageCount, items } = await file.listFiles(
          selectActive,
          pageIndex,
          pageSize,
          activeFilter,
          title
        );

        setTotalItems(total);
        setNumberOfPages(pageCount);

        const dataFinal = await Promise.all(
          items.map(async (item: any) => {
            const finalItem = {
              ...item,
              categoryName: item.categoryName ?? "Não Informada",
            };

            if (item.file) {
              try {
                const { presignedUrl } = await file.getFileFileUrl(item.id);
                finalItem.fileUrl = presignedUrl;
              } catch (error) {
                console.error("Erro ao buscar presignedUrl do arquivo:", error);
              }
            }
            return finalItem;
          })
        );

        setUseDataFiles(dataFinal);
      } catch (error) {
        console.error("Erro ao listar arquivos", error);
      } finally {
        setLoading(false);
      }
    },
    [selectActive]
  );

  useEffect(() => {
    if (selectActive) {
      listFiles(pageSize, currentPage, filterTitle, filterStatus);
    }
  }, [listFiles, pageSize, currentPage, filterTitle, filterStatus, selectActive]);

  useEffect(() => {
    const savedNetwork = localStorage.getItem("selectedNetwork");
    if (savedNetwork) setSelectActive(Number(savedNetwork));
  }, []);

  const handleSelectedHotelChange = (id: number | null) => {
    if (id !== null && id !== selectActive) {
      setSelectActive(id);
      setCurrentPage(1);
    }
  };

  const handleMultiSelectChange = (values: SetStateAction<never[]>) =>
    setSelectedValues(values);

  async function handleFilter(data: any) {
    setFilterTitle(data.title?.toLowerCase() || "");
    setFilterStatus(data.status?.map((s: any) => s.value) || []);
    setCurrentPage(1);
  }

  function resetAll() {
    setPageSize(10);
    setCurrentPage(1);
    setSelectedValues([]);
    reset();
    setFilterTitle("");
    setFilterStatus([]);
  }

  const editFile = (row: IFiles) =>
    navigate("/arquivos/editar-arquivo", {
      state: { isEdit: true, data: row },
    });

  async function downloadDocumentHandler(row: any) {
    if (row.fileUrl) window.open(row.fileUrl, "_blank");
  }

  async function deleteItem(row: any) {
    const idToDelete = row.Id ?? row.id;
    if (!idToDelete) {
      console.error("ID indefinido ao excluir arquivo", row);
      return;
    }
    await file.deleteFile(idToDelete);
    setDeletingFile(null);
    listFiles(pageSize, currentPage, filterTitle, filterStatus);
  }

  async function toggleStatus(row: { Active: boolean; Id?: string; id?: string }) {
    const idToToggle = row.Id ?? row.id;
    if (!idToToggle) {
      console.error("ID indefinido ao alternar status", row);
      return;
    }
    const newActive = !row.Active;
    try {
      setTogglingId(idToToggle);
      setUseDataFiles(prev =>
        prev.map(f =>
          (f.Id === idToToggle || f.id === idToToggle)
            ? { ...f, Active: newActive }
            : f
        )
      );
      await file.updateFileStatus(idToToggle, newActive);
    } finally {
      setTogglingId(null);
    }
  }

  return (
    <Grid2 container spacing={1} mt={5} ml={5} mr={1}>
      <div className="flex w-full">
        <div className="w-1/2">
          <Header
            title="Documentos"
            subTitle="Visualize e gerencie os documentos disponibilizados aos usuários."
            arrowIcon={false}
          />
        </div>
        <div className="flex flex-col items-end gap-5 w-1/2">
          <SelectEnterprise onSelectedHotelChange={handleSelectedHotelChange} />
          <Button
            title="+ Novo documento"
            color="#fff"
            backGroundColor="#F28E00"
            borderRadius={8}
            onClick={() => navigate("/arquivos/cadastrar-arquivo")}
          />
        </div>
      </div>
      <div className="w-screen shadow-custom rounded-lg p-6">
        <form
          className="flex flex-col gap-6"
          onSubmit={handleSubmit(handleFilter)}
        >
          <div className="flex gap-6">
            <div className="w-2/4">
              <Input
                label="Nome"
                placeholder="Digite o nome do documento"
                type="text"
                register={register("title")}
              />
            </div>
            <div className="w-2/4">
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <MultiSelect
                    label="Status"
                    data={dataStatus}
                    onChange={field.onChange}
                    value={field.value}
                    style={{ width: "100%" }}
                    file={false}
                    keyField="value"
                    labelField="label"
                  />
                )}
              />
            </div>
          </div>
          <div className="flex justify-end gap-4">
            <Button
              title="Limpar"
              color="#F28E00"
              backGroundColor="#FCFCFA"
              borderColor="#E3E7FF"
              borderRadius={8}
              onClick={resetAll}
              type="reset"
            />
            <Button
              title="Buscar"
              color="#fff"
              backGroundColor="#F28E00"
              borderRadius={8}
              onClick={handleSubmit(handleFilter)}
            />
          </div>
        </form>
      </div>
      <div className="flex flex-col gap-6 w-screen shadow-custom rounded-lg p-6">
        <div className="flex justify-between">
          <div className="text-[#6D7882] font-main">
            <p>
              <span className="font-bold font-main">{totalItems}</span>{" "}
              itens cadastrados
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <PageSize
              pageSize={pageSize}
              setPageSize={size => {
                setPageSize(size);
                setCurrentPage(1);
              }}
            />
            <p className="text-[#6D7882]">Itens por página</p>
          </div>
        </div>
        <div className="flex justify-center items-center min-h-[200px]">
          {loading ? (
            <Spinner />
          ) : (
            <Table
              data={useDataFiles}
              columns={getColumns(
                editFile,
                setDeletingFile,
                downloadDocumentHandler,
                false,
                toggleStatus,
                togglingId
              )}
              hidePagination
            />
          )}
        </div>

        <div className="flex w-full justify-end">
          <Pagination
            pageCount={numberOfPages}
            currentPage={currentPage}
            setPage={page => setCurrentPage(page)}
          />
        </div>
      </div>

      {deletingFile && (
        <DeleteModal
          itemName={deletingFile.name}
          confirm={() => deleteItem(deletingFile)}
          cancel={() => setDeletingFile(null)}
        />
      )}
    </Grid2>
  );
}
